import React, { useContext } from 'react';

import { ResearchContext } from '../../ResearchContext';


import {
    Autocomplete,
    Grid,
    TextField
} from '@mui/material';
import { SearchType } from "../../../../../helpers";


export function TerritorioFilter() {

    const {

        setState,
        state,

        isLoadingRegioni,
        isLoadingProvince,

        regioneFilter,
        setRegioneFilter,

        provinciaFilter,
        setProvinciaFilter,

        isLoadingFilterFromCookies,
        setIsLoadingFilterFromCookies,

        activeSearchType,

    } = useContext(ResearchContext);

    const {
        regioniOptions,
        province,
        provinceOptions,
    } = state;

    return activeSearchType == SearchType.Regione &&
        <Grid container>
            <Grid item md={6} xs={12} padding={1} >
                <Autocomplete
                    disabled={isLoadingRegioni}
                    fullWidth
                    options={regioniOptions}
                    onChange={(e, value) => {
                        if (isLoadingFilterFromCookies) {
                            setIsLoadingFilterFromCookies(false);
                        }

                        setRegioneFilter(value?.regioneId ?? "");
                        if (value) {
                            setState({ provinceOptions: province.filter(e => e.regioneId == value?.regioneId).map(e => { return { provinciaId: e.id, label: `${e.descrizione} - (${e.sigla})` } }).sort((a, b) => a.label.localeCompare(b.label)) });
                        } else {
                            setState({ provinceOptions: province.map(e => { return { provinciaId: e.id, label: `${e.descrizione} - (${e.sigla})` } }).sort((a, b) => a.label.localeCompare(b.label)) });

                        }
                    }}
                    value={regioniOptions.find(option => option.regioneId == regioneFilter) ?? null}
                    renderInput={(params) => <TextField fullWidth {...params} label="Regione" placeholder='Seleziona la regione' />}
                />
            </Grid>
            <Grid item md={6} xs={12} padding={1}>
                <Autocomplete
                    disabled={isLoadingProvince}
                    fullWidth
                    options={provinceOptions}
                    onChange={(e, value) => {
                        if (isLoadingFilterFromCookies) {
                            setIsLoadingFilterFromCookies(false);
                        }

                        setProvinciaFilter(value?.provinciaId ?? "");
                    }}
                    value={provinceOptions.find(option => option.provinciaId == provinciaFilter) ?? null}
                    renderInput={(params) => <TextField fullWidth {...params} label="Provincia" placeholder='Selezione la provincia' />}
                />
            </Grid>
        </Grid>
}